// import useFetch from '../hooks/useFetch'
// import config from '../config';

import Footer from "./Footer";
import Navbar from "./Navbar";
import Introduction from "./Introduction";


const Test = () => {
    return (
        <div>
            <Navbar/>
            <Introduction/>
                <div className="container">
                <p>
                            esse cillum dolore eu fugiat nulla pariatur. Fusce wisi. Fusce tellus odio, dapibus id fermentum quis, suscipit id erat. Nulla accumsan, elit sit amet varius semper, nulla mauris mollis quam, tempor suscipit diam nulla vel leo. Vivamus ac leo pretium faucibus. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Morbi imperdiet, mauris ac auctor dictum, nisl ligula egestas nulla, et sollicitudin sem purus in lacus. Sed vel lectus. Donec odio tempus molestie, porttitor ut, iaculis quis, sem.
                </p>
                <p>
                            esse cillum dolore eu fugiat nulla pariatur. Fusce wisi. Fusce tellus odio, dapibus id fermentum quis, suscipit id erat. Nulla accumsan, elit sit amet varius semper, nulla mauris mollis quam, tempor suscipit diam nulla vel leo. Vivamus ac leo pretium faucibus. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Morbi imperdiet, mauris ac auctor dictum, nisl ligula egestas nulla, et sollicitudin sem purus in lacus. Sed vel lectus. Donec odio tempus molestie, porttitor ut, iaculis quis, sem.
                </p>
                <p>
                            esse cillum dolore eu fugiat nulla pariatur. Fusce wisi. Fusce tellus odio, dapibus id fermentum quis, suscipit id erat. Nulla accumsan, elit sit amet varius semper, nulla mauris mollis quam, tempor suscipit diam nulla vel leo. Vivamus ac leo pretium faucibus. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Morbi imperdiet, mauris ac auctor dictum, nisl ligula egestas nulla, et sollicitudin sem purus in lacus. Sed vel lectus. Donec odio tempus molestie, porttitor ut, iaculis quis, sem.
                </p>
                <img src="/images/kids.jpg" alt="Logo2" className="p-3 col-lg-4 col-12"/>
                <img src="/images/kids.jpg" alt="Logo2" className="p-3 col-lg-4 col-12"/>
                <img src="/images/kids.jpg" alt="Logo2" className="p-3 col-lg-4 col-12"/>
                </div>
            <Footer/>
        </div>
    );
    
}
export default Test;


// TEST 1
// const { loading, error, data} = useFetch(`${config.api}/api/news?populate[0]=image`);
//     if (loading) return <p>Loading...</p>
//     if(error) return <p>error </p>
//     console.log('xd',data);
//     return (
//         <>
//             <div>
//                 {data.data.map(aktualita => (
//                     <div key={aktualita.id}>
//                         <div>{aktualita.attributes.title}</div>
//                     </div>
//                 ))}
//             </div>
//         </>
//     )